import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { HttpClient } from '@angular/common/http';

/**
 * Generated class for the HomeDashboardLastLogsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-last-logs',
  templateUrl: 'home-dashboard-last-logs.html',
})
export class HomeDashboardLastLogsPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient, ) {

    this.getLog10();
  }

  ionViewDidLoad() {
  }
  log10: any = [];
  data_log: boolean = false;
  async getLog10() {

    await this.http.post(this.globals.analytics_path + 'log10/' + this.globals.restaurant_uid, {}).subscribe(async data => {
      this.log10 = data;
      this.data_log = true;
    },
      err => {
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-last-logs/home-dashboard-last-logs.ts